import type { PlainMessage } from "@bufbuild/protobuf";
import type { Runner } from "gitpod-next-api/gitpod/v1/runner_pb";

export function generateIncrementalName(baseName: string, existingNames: PlainMessage<Runner>[]): string {
    let i = 1;
    const similarNames = existingNames.filter((r) => r.name?.startsWith(baseName)).map((r) => r.name);
    while (similarNames?.includes(`${baseName} ${i}`)) {
        i++;
    }
    return `${baseName} ${i}`;
}
